import React from 'react';

const SearchBar = ({ searchTerm, handleSearch }) => {
    return (
        <div className="flex justify-end mb-6">
            <div className="relative w-full sm:w-1/3">
                <span className="absolute inset-y-0 left-3 flex items-center text-gray-400">
                    🔍
                </span>
                <input
                    type="text"
                    className="pl-10 border border-gray-300 px-4 py-2 rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-all duration-300 w-full"
                    placeholder="Search by name..."
                    value={searchTerm}
                    onChange={handleSearch}
                />
            </div>
        </div>
    );
};

export default SearchBar;